export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-interpolate/src/number.js
// module id = ../../../../d3-interpolate/src/number.js
// module chunks = 3